import React from "react";
import { Link } from "react-router-dom";
import { inject } from "mobx-react";
import { Glyphicon } from "react-bootstrap";
import { StoreContext } from "../../contexts/StoreContext";
import MaintenanceAgencyLabel from "./MaintenanceAgencyLabel";
import "./VariableTree.scss";

@inject("previewStore", "searchStore", "detailViewStore")
class VariableTree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tree: props.model ? this.initTree(props.model) : [],
      frameworks: null,
    };
  }

  initTree = (model) => {
    const arr = [];
    const processItem = (item, parentVariableId = null) => {
      arr.push({
        id: item.variable.tid,
        isOpen: this.props.openItems.includes(item.variable.tid),
        hasChildren: !!item.nodes,
        parentVariableId,
      });
      if (item.nodes) {
        item.nodes.forEach((child) => {
          processItem(child, item.variable.tid);
        });
      }
    };
    if (model && model.length) {
      model.forEach((child) => {
        processItem(child);
      });
    }
    return arr;
  };

  componentDidUpdate() {
    this.setState({ tree: this.initTree(this.props.model) });
  }

  shouldComponentUpdate(nextProps) {
    const { model, openItems } = this.props;
    if (
      nextProps.model?.length !== model?.length ||
      nextProps.openItems !== openItems
    ) {
      return true;
    }

    let isModelDifferent = false;
    for (let i = 0; i < model.length; i++) {
      if (nextProps.model[i].variable.tid !== model[i].variable.tid) {
        isModelDifferent = true;
        break;
      }
    }
    return isModelDifferent;
  }

  checkIfOpen = (id) => {
    const { openItems } = this.props;
    return openItems.includes(id);
  };

  toggleOpen = (id) => {
    const { onOpenChange } = this.props;
    const { tree } = this.state;
    const newTree = [...tree];
    const target = newTree.find((item) => item.id === id);
    if (!target || !target.hasChildren) return;
    target.isOpen = !target.isOpen;
    onOpenChange(
      newTree.filter((item) => item.isOpen === true).map((item) => item.id)
    );
  };

  setFrameworkInUrl = (framework) => {
    const { setSearchFramework } = this.props.searchStore;
    this.setState({ frameworks: framework });
    const url = new URL(window.location);
    url.searchParams.set("framework", framework);
    window.history.pushState({}, null, url);
    setSearchFramework(framework);
  };

  getUrlForVariable = (variable) => {
    const { framework } = this.props;
    let url = `/view/${variable.type}/${variable.tid}`;

    if (framework) {
      return `${url}/?framework=${framework}`;
    }

    return url;
  };
  renderGroup = (children) => {
    if (!children) return null;
    const { framework } = this.props;
    const { setTid, setType, clearEntityData } = this.props.previewStore;
    return (
      <ul>
        {children.map((child, key) => (
          <li key={key}>
            <div className="sdd-tree-item-label">
              {child.nodes && child.nodes.length > 0 ? (
                <Glyphicon
                  glyph={
                    this.checkIfOpen(child.variable.tid) === true
                      ? "triangle-bottom"
                      : "triangle-right"
                  }
                  onClick={() => this.toggleOpen(child.variable.tid)}
                />
              ) : null}
              <span className="sdd-tree-item-name">
                <Link
                  onClick={(e) => {
                    if (this.context.type === "Framework") {
                      e.preventDefault();
                      setType(child.variable.type);
                      setTid(child.variable.tid);
                      this.setFrameworkInUrl(framework);
                    } else {
                      clearEntityData();
                    }
                  }}
                  to={this.getUrlForVariable(child.variable)}
                  // target="_blank"
                >
                  <span>
                    {child.variable.name}
                    <MaintenanceAgencyLabel
                      maintenanceAgencyId={child.variable.maintenanceAgencyId}
                    ></MaintenanceAgencyLabel>
                  </span>
                </Link>
                {` (${child.variable.code}) `}
              </span>
            </div>
            {child.nodes && this.checkIfOpen(child.variable.tid) === true
              ? this.renderGroup(child.nodes)
              : null}
          </li>
        ))}
      </ul>
    );
  };
  static contextType = StoreContext;
  render() {
    const { model } = this.props;
    return (
      <>
        <div className="sdd-variable-tree">
          <div
            className="sdd-variable-tree-container"
            style={{ height: model?.length >= 10 ? "350px" : "auto" }}
          >
            {this.renderGroup(model)}
          </div>
        </div>
      </>
    );
  }
}

export default VariableTree;
